const PREFIX = 'schedule-settings';

export const SETTINGS_TRACKING_IDS = {
  appointmentHours: {
    saveButton: `${PREFIX}:appointment-hours:save-button`,
  },
  appointmentTypes: {
    onlineSchedulingToggleButton: `${PREFIX}:appointment-types:online-scheduling-toggle-button`,
  },
  manageProviders: {
    addProviderButton: `${PREFIX}:manage-providers:add-provider-button`,
    saveScheduleButton: `${PREFIX}:manage-providers:provider-schedule:save-button`,
    onlineSchedulingToggleButton: `${PREFIX}:manage-providers:online-scheduling-toggle-button`,
    showOnCalendarToggleButton: `${PREFIX}:manage-providers:show-on-calendar-toggle-button`,
  },
};
